<template>
  <v-app-bar color="#DAA520" app density="compact" :elevation="3" fixed>
    <v-avatar size="40" class="mx-3">
      <v-img src="logo.png" @click.prevent="showDrawer"> </v-img>
    </v-avatar>
    <v-app-bar-title class="app-bar-title">{{ getPageTitle }}</v-app-bar-title>
    <v-spacer></v-spacer>
    <a
      class="mx-2 text-overline"
      v-if="this.$store.getters.userIsAuthenticated"
      >{{ getCurrentUserAndTerminalID }}</a
    >
  </v-app-bar>
</template>

<script>
export default {
  methods: {
    showDrawer() {
      this.$store.dispatch("toggleShowDrawer");
    },
  },
  computed: {
    getPageTitle() {
      return this.$store.getters.pageTitle;
    },
    getCurrentUserAndTerminalID() {
      return this.$store.getters.currentUserAndTerminalId;
    },
  },
};
</script>

<style scoped>
.image {
  border: 1px;
  mix-blend-mode: multiply;
}

.app-bar-title {
  color: black;
}

@media print {
  header,
  .v-app-bar {
    display: none !important;
  }
}
</style>
